
import http from '@/services/http'

export const SET_LIST_FILA_ATUALIZACAO = 'setListFilaAtualizacao'
export const SET_MESSAGE_ALERT = 'setMessage'
const actions = {


  async gerarTaxasAusentes(context) {
    await http.get('taxas-empresa/adicionar-taxas-ausentes')
      .then(response => context.commit(SET_MESSAGE_ALERT, response.data.data))
      .catch((error) => context.commit(SET_MESSAGE_ALERT, {
        tipo: 'error', message: error.response.data
      }))
  },
    async atualizarVencimentosTaxasViabilidade(context) {
        await http.get('viabilidade/atualizar-vencimentos-taxas')
        .then(response => context.commit(SET_MESSAGE_ALERT, response.data.data))
        .catch((error) => context.commit(SET_MESSAGE_ALERT, {
            tipo: 'error', message: error.response.data
        }))
    },

    async listarFilaAtualizacao(context) {
        await http.get('fila')
        .then(response => context.commit(SET_LIST_FILA_ATUALIZACAO, response.data))
        .catch((error) => context.commit(SET_MESSAGE_ALERT, {
            tipo: 'error', message: error.response.data
        }))
    },

};
const mutations = {

  [SET_MESSAGE_ALERT](state, value) {
    console.log(value)
    let customMessage;
    if (typeof value.message === "object") {

      customMessage = value.message.msg;
    }
    state.mensagem_alert = {
      tipo: value.tipo,
      message: customMessage ? customMessage : value.message,
    };
  },
  [SET_LIST_FILA_ATUALIZACAO](state, value) {
    console.log(value);
    state.lista_fila_atualizacao = value
  },


};
const getters = {

}

const state = {
  mensagem_alert: [],
  lista_fila_atualizacao: [],
};

export default {
  actions,
  getters,
  mutations,
  state,
  namespaced: true,
};


